export default "__VITE_ASSET__lkKQNIay__"